import React from "react";
import { CheckCircle, Circle, ClockClockwise } from "@phosphor-icons/react";

// Customer-facing simplified timeline
const CUSTOMER_STAGES = [
  { key: "submitted", label: "Request Submitted" },
  { key: "under_review", label: "Under Review" },
  { key: "estimate_ready", label: "Estimate & Sample Ready" },
  { key: "awaiting_payment", label: "Approve & Pay" },
  { key: "in_production", label: "In Production" },
  { key: "ready", label: "Ready to Download" },
  { key: "delivered", label: "Delivered" },
];

const orderIndex = (status) => {
  const rank = {
    draft: 0, submitted: 1, under_review: 2, clarification_required: 2,
    estimate_in_preparation: 2, estimate_ready: 3, awaiting_decision: 3,
    revision_requested: 3, revised_quote_ready: 3, awaiting_payment: 4,
    payment_processing: 4, paid: 5, in_production: 5, quality_review: 5,
    quality_rework: 5, ready_for_delivery: 6, ready: 6,
    delivered: 7, completed: 7,
  };
  return rank[status] ?? 0;
};

export default function Timeline({ currentStatus }) {
  const current = orderIndex(currentStatus);
  return (
    <div className="relative pl-6">
      <div className="absolute left-2 top-1 bottom-1 w-px bg-border" />
      {CUSTOMER_STAGES.map((s, i) => {
        const rank = orderIndex(s.key);
        const done = rank < current;
        const active = rank === current;
        return (
          <div key={s.key} data-testid={`timeline-step-${s.key}`} className="relative mb-5 flex items-start gap-3">
            <div className={`absolute -left-6 top-0.5 rounded-full ${done ? "text-emerald-600" : active ? "text-primary" : "text-muted-foreground"}`}>
              {done ? <CheckCircle size={16} weight="fill" /> : active ? <ClockClockwise size={16} weight="fill" /> : <Circle size={16} />}
            </div>
            <div>
              <div className={`text-sm font-medium ${active ? "text-foreground" : done ? "text-emerald-700" : "text-muted-foreground"}`}>
                {s.label}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
